export enum SurveyTypeEnum {
  SUB_CANCELLATION = 'sub-cancellation',
}

export enum SurveyAnswerStatusEnum {
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED',
  COMPLETED = 'COMPLETED',
}

export enum SurveyQuestionTypeEnum {
  CHECK = 'check',
  RADIO = 'radio',
  TEXT = 'text',
  RANGE = 'range',
}
